import { render, staticRenderFns } from "./OwalEventBannerPosterFrame.vue?vue&type=template&id=4b6d1b34&scoped=true"
import script from "./OwalEventBannerPosterFrame.vue?vue&type=script&lang=js"
export * from "./OwalEventBannerPosterFrame.vue?vue&type=script&lang=js"
import style0 from "./OwalEventBannerPosterFrame.vue?vue&type=style&index=0&id=4b6d1b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6d1b34",
  null
  
)

export default component.exports